import React from "react";

export default function SQL_PROCEDURE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_PROCEDURE</h1>
      <p>This is the SQL_PROCEDURE component generated from the SQL JSON.</p>
    </div>
  );
}
